import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "./services/authentication/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BusinessOwnerService} from "./services/business-owner/business-owner.service";
import {BusinessOwnerDto} from "./model/business/dto/business-owner-dto";
import {AlertService} from "./services/alert/alert.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  title = "black-dashboard-angular";

  checking = false;

  constructor(public translate: TranslateService,
              private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private alertService: AlertService,
              private businessOwnerService: BusinessOwnerService) {

    translate.addLangs(['en', 'ro']);
    let lang = localStorage.getItem('lang');
    if (!lang) {
      lang = 'ro';
    }
    translate.setDefaultLang(lang);
  }

  ngOnInit() {
    let shouldCheckAuthentication = true;
    let redirectPath = null;
    if (window.location.hash) {
      // If current URL contains hash '#', it meanse that is trying to access a specific app page
      // and if that hash contains the access_token it means that it was a redirect made after external Auth0 login
      if (window.location.hash.indexOf("access_token") >= 0) {
        shouldCheckAuthentication = false;
        // Need to extract the details provided after external Auth0 login
        this.authService.handleAuthentication().then(
          () => {
            this.checkAuthentication();
          }
        );
      } else if (window.location.hash.indexOf("/public") >= 0) {
        // This is a public page and authentication should not be checked
        shouldCheckAuthentication = false;
      } else {
        // In case it was set a redirect path on logout
        redirectPath = "/" + window.location.hash;
      }
    }
    if (shouldCheckAuthentication) {
      this.checkAuthentication(redirectPath);
    }
  }

  checkAuthentication(redirectPath?: string) {
    if (!this.authService.isAuthenticated()) {
      if (redirectPath) {
        localStorage.setItem('redirect-path', redirectPath.replace("/#", ""));
      }
      this.authService.login();
    }
  }
}
